/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Copilot_Disable_ScheduledInputs */



/**
* | output |
* | --- |
* | "Copilot disable scheduled." |
*
* @param {Partner_Manage_Copilot_Disable_ScheduledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_copilot_disable_scheduled = /** @type {((inputs?: Partner_Manage_Copilot_Disable_ScheduledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Copilot_Disable_ScheduledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Copilot-Deaktivierung geplant.")
	return /** @type {LocalizedString} */ ("Copilot disable scheduled.")
});